// extracted by mini-css-extract-plugin
export default {"title":"ShareDialog_title__BycXg","copy":"ShareDialog_copy__xYrn8","input":"ShareDialog_input__gSFol","button":"ShareDialog_button__43BbG"};